import React from "react";
import {Avatar} from "../../../schema";
import {DialogueHistoryEntry} from "../../../redux/player/types";
import Content from "./content/Content";
import {ContentItem} from "./ContentDisplay";
import Scroll from "../../../ui/scroll";
import {PhraseVariant} from "../../Phrase";
import {ChoiceUserInputDisplayMode} from "../../../redux/player/selectors/getCurrentActionChoiceMode";
import classes from "./ModernPlayer.module.css";
import cn from "classnames";

type ActionsHistoryPanelProps = {
  dialogueHistory: DialogueHistoryEntry[];
  avatar: Avatar;
  openFullscreenMedia: () => void;
  contentClassName?: string;
};

export default function ActionsHistoryPanel({
  dialogueHistory,
  avatar,
  openFullscreenMedia,
  contentClassName
}: ActionsHistoryPanelProps) {
  if (dialogueHistory.length === 0) {
    return null;
  }

  return (
    <div className={cn(classes.content, classes.actionsHistoryPanel)}>
      <Scroll className={cn(classes.actionsHistoryScroll, contentClassName)}>
        {dialogueHistory.map((entry, historyIndex) => (
          <Content.Container key={`${entry.action.id}-${historyIndex}`}>
            <ContentItem
              avatar={avatar}
              openFullscreenMedia={openFullscreenMedia}
              action={entry.action}
              phraseMode={PhraseVariant.DEFAULT}
              choiceMode={ChoiceUserInputDisplayMode.ALL}
              displayMode={undefined}
              chosenBranches={entry.chosenBranchIds ? new Set(entry.chosenBranchIds) : new Set()}
              recognizedText={entry.recognizedText}
              feedbackText={entry.feedbackText}
              onlyShowChosenBranches={entry.chosenBranchIds != null && entry.chosenBranchIds.length > 0}
              isError={false}
              isHistory
            />
          </Content.Container>
        ))}
      </Scroll>
    </div>
  );
}
